import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ventajasTranslations } from '../data/translations/ventajasTranslations';

export default function Ventajas() {
  const { language } = useLanguage();
  const t = ventajasTranslations[language].ventajas;

  return (
    <div className="bg-background text-on-surface font-body">
      <section className="py-24 bg-primary text-on-primary overflow-hidden">
        <div className="max-w-7xl mx-auto px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-headline text-3xl lg:text-4xl font-bold mb-8 leading-tight">
              {t.title}
            </h2>
            <p className="opacity-70 text-lg mb-10 leading-relaxed">
              {t.description}
            </p>
            <div className="space-y-6">
              {t.features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <span className="material-symbols-outlined text-secondary">check_circle</span>
                  <div>
                    <div className="font-bold text-lg mb-1">{feature.title}</div>
                    <div className="opacity-60 text-sm">{feature.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="aspect-video bg-slate-800 rounded-xl overflow-hidden border border-slate-700 shadow-2xl">
              <img alt="Médico en estación de trabajo" className="w-full h-full object-cover opacity-60 mix-blend-overlay" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBQ2dGAeINQ5foG1hAgchspyhL9NW_8anc6_px4FrI8HAt0MRiHQTCkh4ACQp26yidA1FPW-mfwhzkU7n_wNFQ8cHOvGEiq0xjsHlF7KfSgTxP6OUCavFRT1sfSZSiuvR6n3HqtvlGIA1w6LVJxbuAB1yr0mA4vg5UgY5AxMsv2_bUl7GK0m97AAff-Bkz7HvLqCRen_yiQiqL1NgeoYIApfhYZH3jfRNJQQCOZtU6uzE4PE1zo5XGRKIw3irCnytO18LNQmhOxZLM" />
            </div>
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-secondary/10 rounded-full blur-2xl"></div>
          </div>
        </div>
      </section>
    </div>
  );
}